import React from 'react';
import { Checkbox, List, Popup } from 'semantic-ui-react';
import momentTZ from 'moment-timezone';

export const hasLinkedInUrl = (expert) => (
  expert.publicLinks || []
).some((url) => url.toLowerCase().includes('linkedin.com'));

const formatDate = (date, timeZone) => {
  if (!date) return 'Never';
  return momentTZ.tz(date, timeZone).format('MM/DD/YYYY');
};

const ExpertWizaUpdateSelection = ({
  expert,
  selected,
  onChange,
  timeZone,
}) => {
  const eligible = hasLinkedInUrl(expert);
  const checkbox = (
    <Checkbox
      checked={selected}
      disabled={!eligible}
      label={eligible ? 'Select for Wiza update' : 'No LinkedIn URL'}
      onChange={() => onChange(expert.id)}
    />
  );

  return (
    <div className="wiza-selection">
      {eligible ? checkbox : (
        <Popup
          trigger={<span>{checkbox}</span>}
          content="Wiza requires a LinkedIn profile URL."
          position="top center"
        />
      )}
      <div className="wiza-dates">
        <List>
          <List.Item>
            {`Last profile update at: ${formatDate(expert.profileUpdatedAt, timeZone)}`}
          </List.Item>
          <List.Item>
            {`Last Wiza update at: ${formatDate(expert.wizaUpdatedAt, timeZone)}`}
          </List.Item>
        </List>
      </div>
    </div>
  );
};

export default ExpertWizaUpdateSelection;
